// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__4ypeU","container":"RichText_container__5TIQN","textlink":"RichText_textlink__2Izwf","textLink__icon":"RichText_textLink__icon__uciSZ"};